import React, { useRef, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate } from 'react-router-dom'
import { RiImageAddLine } from "react-icons/ri";
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';


const AddNewBanner = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [bannertitle, setBannerTitle] = useState('');
    // const [bannerdescription, setBannerDescription] = useState('');
    // const [bannertype, setBannerType] = useState('');
    const [bannerlink, setBannerLink] = useState('');
    const [activedate, setActiveDate] = useState('');
    const [expirationdate, setExpirationData] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);


    const fileInputRef = useRef(null);

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('bannerTitle', bannertitle);
        // formData.append('bannerDescription', bannerdescription);
        // formData.append('type', bannertype);
        formData.append('bannerLink', bannerlink);
        formData.append('activationDate', activedate);
        formData.append('expirationDate', expirationdate);
        formData.append('image', image);


        await postApi(endPoints.addbanner, formData, {
            setLoading,
            successMsg: 'Banner added successfully!',
            errorMsg: 'Failed to add banner!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/banner-Management'); // Redirect to the Privacy Policy list page
        }, 2000);
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUploadClick = () => fileInputRef.current?.click();

    const handleClearImage = () => {
        setImage(null);
        setImagePreview(null);
    };

    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Created"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Add New Banner </h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Banners</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Banner  Details</h6>
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Banner Name*</label>
                            <input
                                type="text"
                                placeholder='Enter the Banner Name'
                                value={bannertitle}
                                onChange={(e) => setBannerTitle(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addbannercontainer}>
                            <label htmlFor="">Banner Image*</label>
                            <div className={addjob.addbannerinput}>
                                {imagePreview ? (
                                    <>
                                        <div className={addjob.editbannerimage}>
                                            <img src={imagePreview} alt="" />
                                        </div>
                                        <span onClick={handleClearImage}>Clear</span>
                                    </>
                                ) : (
                                    <>
                                        <div className={addjob.addbannerupload} onClick={handleUploadClick}>
                                            <RiImageAddLine color='#8D98AA' size={35} />
                                            <p>Upload your file</p>
                                        </div>
                                        <span>Max 2MB</span>
                                    </>
                                )}
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                hidden
                            />
                        </div>
                        <div className={addjob.addvouchercontainer}>
                            {/* <div className={addjob.addjobinputs}>
                                <label htmlFor="">Choose App*</label>
                                <select name="" id="">
                                    <option value="">User / Client</option>
                                </select>
                            </div> */}
                            {/* <div className={addjob.addjobinputs}>
                                <label htmlFor="">Position*</label>
                                <select name="" id="">
                                    <option value="">Home/Chat/Jobs etc..</option>
                                </select>
                            </div> */}
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Target Link*</label>
                                <input
                                    type="text"
                                    placeholder='Enter target link'
                                    value={bannerlink}
                                    onChange={(e) => setBannerLink(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className={addjob.addnewbanner}>
                            <div className={addjob.addjobtopic}>
                                <h6>Validity</h6>
                            </div>
                            <div className={addjob.addvouchercontainer}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Start Date *</label>
                                    <input
                                        type="date"
                                        placeholder='Please enter Staters'
                                        value={activedate}
                                        onChange={(e) => setActiveDate(e.target.value)}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">End Date*</label>
                                    <input
                                        type="date"
                                        placeholder='Please enter Staters'
                                        value={expirationdate}
                                        onChange={(e) => setExpirationData(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading}
                            >
                                {loading ? "Creating..." : "Create"}
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HOC(AddNewBanner)